import { FC } from 'react'
import Swal from 'sweetalert2'
import { RowActions, useModal } from '../../../../../../components'
import {
  downloadArquivo,
  IconPaths,
  showAlertLoading,
  showError,
} from '../../../../../../../_metronic/helpers'
import { downloadAvaliacao, getFormularioAtendimento } from '../../core/_requests'
import { FormularioAtendimentoList } from '../../../avaliacoes-pendentes-list/core/_models'
import { FormularioViewModal } from '../../../avaliacoes-pendentes-list/components/modal/FormularioViewModal'

type Props = {
  formularioAtendimento: FormularioAtendimentoList
}

export const AvaliacoesActionsCell: FC<Props> = ({ formularioAtendimento }) => {
  const { showModal } = useModal()
  const paciente =
    formularioAtendimento.paciente?.pessoa?.nome ?? formularioAtendimento.paciente?.nome
  const nome = `Avaliação de ${paciente ?? ''}`.trim()

  const handleDownload = async () => {
    try {
      showAlertLoading()
      const arquivo = await downloadAvaliacao(
        formularioAtendimento.atendimento.id,
        formularioAtendimento.id
      )
      downloadArquivo(arquivo)
      Swal.close()
    } catch (error) {
      showError(error)
    }
  }

  const showAvaliacao = () =>
    showModal({
      title: nome,
      content: <FormularioViewModal />,
      fetchers: {
        formulario: () =>
          getFormularioAtendimento(formularioAtendimento.atendimento.id, formularioAtendimento.id),
      },
    })

  return (
    <RowActions
      itemName={nome}
      primaryAction={
        formularioAtendimento.concluido
          ? { label: 'Baixar', onClick: handleDownload, icon: IconPaths.Download }
          : { label: 'Ver avaliação', onClick: showAvaliacao, icon: IconPaths.Search }
      }
    />
  )
}
